import React from 'react'
import classNames from 'classnames'
import { NavLink } from 'react-router-dom'
import { useNavItemContext } from '../../TopLevelNavItem/NavItemContext'
import { useNavigationContext } from '#src/components/Header/StandardHeader/NavigationContext'
//@ts-ignore Need props for react-hoverintent
import HoverIntent from 'react-hoverintent'
import ArrowRight from '#src/components/Header/StandardHeader/icons/arrow-right.svg'
import { FlatDepartment } from '../../../../types'
import styles from './styles.css'

interface DepartmentsColumnProps {
  flatDepartments: FlatDepartment[]
}

const DepartmentsColumn: React.FC<DepartmentsColumnProps> = ({ flatDepartments }) => {
  const navContext = useNavigationContext()
  const navItemContext = useNavItemContext()

  return (
    <div className={styles.column}>
      <div className={styles.departments} data-testid="desktop-browse-menu-departments">
        {flatDepartments.map((flatDepartment, departmentIndex) => {
          // The active department is stored in context. If no context is available, we select the
          //   first department by default.
          let isActiveDepartmentFromContext =
            navContext?.activeDepartmentSlug === flatDepartment.referenceSlug
          let isActiveDepartmentByDefault =
            !navContext?.activeDepartmentSlug && departmentIndex === 0

          return (
            <HoverIntent
              key={`${flatDepartment.referenceSlug || ''}${flatDepartment.slug}`}
              onMouseOver={() => {
                navContext?.onSetActiveDepartmentSlug(flatDepartment.referenceSlug)
              }}
              onMouseOut={() => null}
              sensitivity={10}
              interval={90}
              timeout={150}
            >
              <NavLink
                to={`/d/${flatDepartment.slug}`}
                onClick={() => {
                  navItemContext?.onNavItemSelected()
                }}
                className={classNames(styles.department, {
                  [styles.activeDepartment]:
                    isActiveDepartmentFromContext || isActiveDepartmentByDefault
                })}
              >
                <div className={styles.navItemHighlight}>
                  <div className={styles.navItemHighlightLabel}>{flatDepartment.displayName}</div>
                  <ArrowRight className={styles.navItemHighlightArrow} />
                </div>
              </NavLink>
            </HoverIntent>
          )
        })}
      </div>
    </div>
  )
}

export default DepartmentsColumn
